import { makeStyles } from "@mui/styles";
import React from "react";
import { TableCell, TableRow} from "@mui/material";

// CSS styling
const useStyles = makeStyles((theme) => ({
  row: {
    backgroundColor: theme.palette.common.white,
  },
}));

// Renders Item Search data into table rows
export default function ItemSearchList({ data }){
  const classes = useStyles();
  return (
    <>
      {data &&
        data.map((item, index) => (
          <TableRow
	    hover
            key={`${item.productCode}-${item.warehouse}` || index}
	  >
            {/* Products */}
            <TableCell className={classes.row}>{item.productCode}</TableCell>
            <TableCell className={classes.row}>{item.productName}</TableCell>
            <TableCell className={classes.row}>{item.barcode}</TableCell>
            <TableCell className={classes.row}>{item.unitsPerInner}</TableCell>
            <TableCell className={classes.row}>{item.unitsPerCarton}</TableCell>
            <TableCell className={classes.row}>{"$" + (item.retailPrice * 1).toFixed(2)}</TableCell>
            <TableCell className={classes.row}>{"$" + (item.quantityPrice * 1).toFixed(2)}</TableCell>
            <TableCell className={classes.row}>{"$" + (item.wholesalePrice * 1).toFixed(2)}</TableCell>
            
            {/* Inventory */}
            <TableCell className={classes.row}>{item.warehouse}</TableCell>
            <TableCell className={classes.row}>
              {(item.inStock * 1).toFixed(0)}
            </TableCell>
            <TableCell className={classes.row}>
              {(item.committed * 1).toFixed(0)}
            </TableCell>
            <TableCell className={classes.row}>
              {(item.available * 1).toFixed(0)}
            </TableCell>
            <TableCell className={classes.row}>
              {(item.arrivalQuantity * 1).toFixed(0)}
            </TableCell>
            <TableCell className={classes.row}>
              {item.eta ? item.eta : ""}
            </TableCell>
          </TableRow>
        ))
      }
    </>
  );
};
